<template>
  <div class="modal-outer">
    <div class="modal-inner">

      <ul class="menu-wrapper">
        <li class="menu-item">
          <button class="nav-btn" @click="handleNavigation('/')">
            <span class="do-hyeon-regular">홈</span>
          </button>
        </li>
        <li class="menu-item">
          <button class="nav-btn" @click="handleNavigation('/about')">
            <span class="do-hyeon-regular">젊은이부 소개</span>
          </button>
<!--          <router-link to="/about">-->
<!--            <span class="do-hyeon-regular">젊은이부 소개</span>-->
<!--          </router-link>-->
        </li>
        <li class="menu-item">
          <button class="nav-btn" @click="handleNavigation('/gallery')">
            <span class="do-hyeon-regular">갤러리</span>
          </button>
<!--          <router-link to="/gallery">-->
<!--            <span class="do-hyeon-regular">갤러리</span>-->
<!--          </router-link>-->
        </li>
        <li class="menu-item">
          <div class="divider"></div>
        </li>
        <li class="menu-item family-site">
          <a target="_blank" href="https://www.youtube.com/@%EC%B2%9C%ED%98%B8%EC%A0%9C%EC%9D%BC%EA%B0%90%EB%A6%AC%EA%B5%90%ED%9A%8C%EC%A0%8A%EC%9D%80/streams">
            <i class="bi bi-youtube" style="font-size: 16px; margin-right: 8px"></i> AXIS 유튜브
          </a>

        </li>
        <li class="menu-item family-site">
          <a target="_blank" href="http://www.chunhojeil.com/main/main.html">
            <i class="bi bi-box-arrow-up-right" style="font-size: 14px; margin-right: 8px"></i> 본교회 홈페이지
          </a>
        </li>
        <li class="menu-item">
          <button @click="closeMenuModal" class="close-btn" type="button">
            <i class="bi bi-x"></i>
          </button>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "MenuModal",
  props: {
    closeMenuModal: {
      type: Function
    }
  },

  methods: {
    goHome() {
      if (this.$route.path === '/') {
        // 현재 경로가 홈일 경우 모달만 닫음
        this.closeMenuModal();
      } else {
        // 홈이 아니면 새로고침 없이 홈으로 이동
        this.$router.push('/');
        this.closeMenuModal(); // 홈으로 이동 후 모달도 닫음
      }
    },

    handleNavigation(targetRoute) {
      if (this.$route.path === targetRoute) {
        // 동일한 경로일 경우 모달만 닫음
        this.closeMenuModal();
      } else {
        // 다른 경로로 이동 후 모달을 닫음
        this.$router.push(targetRoute).then(() => {
          this.closeMenuModal();
        });
      }
    },
  }
}
</script>

<style scoped lang="scss">
.modal-outer {

  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);

  .modal-inner {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    .close-btn {
      background-color: transparent;
      box-sizing: border-box;
      padding: 0;
      border: none;

      i {
        color: #fff;
        font-size: 40px;
      }
    }

    .menu-wrapper {

      .menu-item {

        box-sizing: border-box;
        padding: 25px;

        .nav-btn {
          box-sizing: border-box;
          padding: 0;
          border: none;
          background-color: transparent;

          span {
            color: #fff;
            font-size: 32px;
          }
        }

        &.family-site {
          a {
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        a {
          color: #fff;
          font-size: 32px;
        }

        .divider {
          width: 20px;
          height: 1px;
          background-color: #fff;
          margin: 0 auto;
        }

      }

    }
  }
}
</style>